import { Icon } from "@/components/ui/icon";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface Education {
  id: string;
  degree_or_certification: string;
  institution: string;
  status?: string;
  display_order: number;
}

interface EducationSectionProps {
  education: Education[];
}

export const EducationSection = ({ education }: EducationSectionProps) => {
  if (education.length === 0) return null;

  return (
    <section id="education" className="section-padding bg-background">
      <div className="max-w-6xl mx-auto container-padding">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-3 animate-fade-in">
          Education & Certifications
        </h2>
        <p className="text-muted-foreground mb-10 animate-fade-in animation-delay-100">
          Academic background and professional certifications
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {education.map((edu, index) => (
            <Card
              key={edu.id}
              className="p-5 hover:shadow-md transition-all duration-200 animate-fade-in"
              style={{ animationDelay: `${(index + 1) * 100}ms` }}
            >
              <div className="flex items-start gap-4">
                <div className="size-11 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="school" size={22} className="text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-foreground mb-1 leading-tight">
                    {edu.degree_or_certification}
                  </h3>
                  <p className="text-muted-foreground text-sm mb-2">
                    {edu.institution}
                  </p>
                  {edu.status && (
                    <Badge
                      variant="success"
                      className="text-xs px-2.5 py-0.5 rounded-full"
                    >
                      {edu.status}
                    </Badge>
                  )}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
